import { Box } from '@material-ui/core'
import { ContainerProps } from 'react-three-fiber/targets/shared/web/ResizeContainer'
import { Canvas as R3FCanvas } from 'react-three-fiber'
import React from 'react'
import styled from 'styled-components'

export const StickyZone = styled(Box)`
    ${({ theme }) => `
        height: 47vw;
           
        ${theme.breakpoints.up('md')} {
            height: ${theme.spacing(450)};
        }
    `}
`

export const AnimationContainer = styled(Box)`
    ${({ theme }) => `
        height: 47vw;
        margin-top: ${theme.spacing(20)};
        max-height: 700px;
        position: sticky;
        top: ${theme.spacing(20)};
    `}
`

type CanvasProps = ContainerProps & {
    isHover: boolean
}

export const Canvas = styled(({ isHover, ...rest }: CanvasProps) => <R3FCanvas {...rest} />)`
    ${({ isHover }: CanvasProps) => `
        top: 0;
        cursor: ${isHover ? 'pointer' : 'default'};
    `}
`
